import { useContext } from 'react'
import { SelectedProductContext } from '~/components/Panels/SelectedProductPanel/components/SelectedProductContext'

export const useSelectedProductContext = () => {
  const value = useContext(SelectedProductContext)
  if (!value) throw new Error('useSelectedProductContext must be used within context')
  return value
}
